<template>
  <div v-if="isSuperAdmin()">
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button
          block
          v-b-toggle.accordion-1
          variant="info"
        >{{$t('customization_table.media_server.title')}}</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div class="box-body">
            <!-- <div class="row"> -->
            <div class="col-md-12">
              <div class="form-group">
                <label for="title">{{$t('customization_table.media_server.media_domain')}}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="media_server.media_domain"
                  :placeholder="$t('customization_table.media_server.media_domain')"
                />
              </div>
            </div>
            <!-- </div> -->
            <!-- <div class="row"> -->
            <div class="col-md-6">
              <div class="form-group">
                <label for="title">{{$t('customization_table.media_server.media_username')}}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="media_server.media_username"
                  :placeholder="$t('customization_table.media_server.media_username')"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group">
                <label for="title">{{$t('customization_table.media_server.media_password')}}</label>
                <input
                  class="form-control"
                  v-model="media_server.media_password"
                  @input="validatePassword(media_server.media_password)"
                  type="password"
                  id="password_media"
                  :placeholder="$t('customization_table.media_server.media_password')"
                />
                <span
                  :class="{ password_length_count : valid_password_length, show_password_length : password_typed }"
                  class="password_length"
                >{{ password_length }}</span>

                <div v-show="password_typed" class="lnu_container">
                  <p :class="{ got_lowercase : contain_lowercase}">{{$t('user.lowercase')}}</p>
                  <p :class="{ got_number : contain_number }">{{$t('user.digit')}}</p>
                  <p :class="{ got_uppercase : contain_uppercase }">{{$t('user.uppercase')}}</p>
                </div>
              </div>
            </div>
            <!-- </div> -->
            <div class="box-footer" style="padding-bottom: 0">
              <button
                type="button"
                class="btn btn-labeled btn-success pull-right"
                style="margin-right: 5px;"
                @click="onSave"
              >
                <span class="btn-label">
                  <i class="glyphicon glyphicon-ok"></i>
                </span>
                {{$t('common.save')}}
              </button>
            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>

    <!-- MEDIA Project -->
    <div v-if="GET_MEDIA_CONFIG_DATA.media_domain">
    <b-card no-body class="mb-1" v-if="show_media_project">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button
          block
          v-b-toggle.accordion-2
          variant="info"
        >{{$t('customization_table.media_project.title')}}</b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
        <b-card-body>
          <div class="box-body">
            <div class="col-md-6">
              <div class="form-group">
                <label for="title">{{$t('customization_table.media_project.project_name')}}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="media_project.project_name"
                  :placeholder="$t('customization_table.media_project.project_name')"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label for="title">{{$t('customization_table.media_project.page_size')}}</label>
                <input
                  type="number"
                  class="form-control"
                  v-model="media_project.page_size"
                  :placeholder="$t('customization_table.media_project.page_size')"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="title">{{$t('customization_table.media_project.description')}}</label>
                <textarea
                    rows="5"
                    type="text"
                    maxlength="250"
                    class="form-control"
                    v-model="media_project.description"
                    :placeholder="$t('customization_table.media_project.description')"
                />
              </div>
            </div>
            <div class="box-footer" style="padding-bottom: 0">
              <button
                type="button"
                class="btn btn-labeled btn-success pull-right"
                style="margin-right: 5px;"
                @click="onSave_MEDIA_Project"
              >
                <span class="btn-label">
                  <i class="glyphicon glyphicon-ok"></i>
                </span>
                {{$t('common.save')}}
              </button>
            </div>
          </div>
        </b-card-body>
      </b-collapse>
    </b-card>
    <p v-else style="color: red; text-align: center">{{$t('customization_table.media_server.info_incorrect')}}</p>
    </div>
    <lte-core-alert v-for="snackbar in GET_SNACK_BAR" :key="snackbar.id" :item="snackbar"></lte-core-alert>
    <loading 
      :active.sync="is_loading" 
      :can-cancel="false" 
      color="#1E90FF">
    </loading>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";
import Loading from "vue-loading-overlay";
import utils from '@/lib/utils'

export default {
  name: "CustomizationTable_Media",
  data() {
    return {
      media_server: {
        media_domain: null,
        media_username: "",
        media_password: ""
      },
      password_length: 0,
      password_typed: false,
      contain_lowercase: false,
      contain_uppercase: false,
      contain_number: false,
      valid_password_length: false,
      valid_password: false,
      media_project: {
        project_name: "",
        page_size: null,
        description: ""
      },
      show_media_project: false,
      is_loading: false
    };
  },
  watch: {
    GET_MEDIA_CONFIG_DATA: function() {
      this.media_server.media_domain = this.GET_MEDIA_CONFIG_DATA.media_domain;
      this.media_server.media_username = this.GET_MEDIA_CONFIG_DATA.media_username;
      // this.media_server.media_password = this.GET_MEDIA_CONFIG_DATA.media_password;
    },
    GET_MEDIA_PROJECT_DATA: function() {
      this.media_project.project_name = this.GET_MEDIA_PROJECT_DATA.name;
      this.media_project.page_size = this.GET_MEDIA_PROJECT_DATA.pagination;
      this.media_project.description = this.GET_MEDIA_PROJECT_DATA.description;
    }
  },
  computed: {
    ...mapGetters([
      "GET_ACCOUNT_DATA",
      "GET_MEDIA_CONFIG_DATA",
      "GET_SNACK_BAR",
      "GET_MEDIA_PROJECT_DATA"
    ])
  },
  methods: {
    ...mapActions([
      "GET_MEDIA_CONFIG",
      "PUSH_MEDIA_CONFIG",
      "SUCCESS_TOAST",
      "ON_SHOW_TOAST",
      "GET_MEDIA_PROJECT",
      "PUSH_MEDIA_PROJECT"
    ]),
    isSuperAdmin: function() {
        return utils.isSuperAdmin(this.GET_ACCOUNT_DATA);
    },
    onSave: function() {
      let result = this.validateData();
      if (result == "OK") {
        let data = {
          media_password: utils.getCleanStringValue(this.media_server.media_password),
          media_username: utils.getCleanStringValue(this.media_server.media_username),
          media_domain: utils.getCleanStringValue(this.media_server.media_domain)
        };
        this.PUSH_MEDIA_CONFIG(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
              this.GET_MEDIA_CONFIG();
              this.getMediaProject();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      } else if (result != "OK") {
        this.ON_SHOW_TOAST({
          message: result,
          styleType: "danger"
        });
      } else {
        this.ON_SHOW_TOAST({
          message: "This password is not valid",
          styleType: "danger"
        });
      }
    },
    validatePassword: function(password) {
      this.password_length = password.length;

      if (this.password_length > 7) {
        this.valid_password_length = true;
      } else {
        this.valid_password_length = false;
      }

      if (this.password_length > 0) {
        this.password_typed = true;
      } else {
        this.password_typed = false;
      }

      this.contain_lowercase = /[a-z]/.test(password);
      this.contain_uppercase = /[A-Z]/.test(password);
      this.contain_number = /\d/.test(password);

      if (
        this.contain_lowercase == true &&
        this.contain_uppercase == true &&
        this.contain_number == true &&
        this.valid_password_length == true
      ) {
        this.valid_password = true;
      } else {
        this.valid_password = false;
      }
      return this.valid_password;
    },
    validateData: function() {
      let validatedResult = "OK";
      if (this.validatePassword(this.media_server.media_password) === false) {
        validatedResult = "This password is not valid";
      }
      for (let key in this.media_server) {
        if (this.media_server[key] === null || this.media_server[key] === "") {
          validatedResult =
            "Vui Lòng Nhập: " +
            this.$t("customization_table.media_server." + key);
          break;
        } else {
          //
        }
      }
      return validatedResult;
    },
    onSave_MEDIA_Project: function() {
      if (this.media_project.page_size <= 0) {
        this.ON_SHOW_TOAST({
          message: "Page size not validate",
          styleType: "danger"
        });
      } else {
        let data = {
          project_name: utils.getCleanStringValue(this.media_project.project_name),
          page_size: this.media_project.page_size,
          description: utils.getCleanStringValue(this.media_project.description)
        };
        this.PUSH_MEDIA_PROJECT(data)
          .then(
            function(res) {
              this.SUCCESS_TOAST();
            }.bind(this)
          )
          .catch(
            function(error) {
              this.ON_SHOW_TOAST({
                message: error.response.data.message,
                styleType: "danger"
              });
            }.bind(this)
          );
      }
    },
    getEventFromSMTP: function(){
      this.GET_MEDIA_CONFIG();
      this.getMediaProject();
    },
    getMediaProject: function(){
      this.is_loading=true;
      this.GET_MEDIA_PROJECT().then(
        function(res) {
          this.show_media_project=true;
          this.is_loading=false;
        }.bind(this)
      ).catch(
        function(error) {
        this.show_media_project=false;
        this.is_loading=false;
        }.bind(this)
      );
    }
  },
  mounted() {
    // this.GET_MEDIA_CONFIG();
    // this.GET_MEDIA_PROJECT();
  },
  components: {
    "lte-core-alert": LTECoreAlert,
    loading: Loading,

  }
};
</script>

<style scoped>
.panel.with-nav-tabs .panel-heading {
  padding: 5px 5px 0 5px;
}
.panel.with-nav-tabs .nav-tabs {
  border-bottom: none;
}
.panel.with-nav-tabs .nav-justified {
  margin-bottom: -1px;
}
/********************************************************************/
/*** PANEL WARNING ***/
.with-nav-tabs.panel-warning .nav-tabs > li > a,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning .nav-tabs > .open > a,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > .open > a:focus,
.with-nav-tabs.panel-warning .nav-tabs > li > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li > a:focus {
  color: #8a6d3b;
  background-color: #faebcc;
  border-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.active > a,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:hover,
.with-nav-tabs.panel-warning .nav-tabs > li.active > a:focus {
  color: #8a6d3b;
  background-color: #fff;
  border-color: #faebcc;
  border-bottom-color: transparent;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu {
  background-color: #fcf8e3;
  border-color: #faebcc;
}
.with-nav-tabs.panel-warning .nav-tabs > li.dropdown .dropdown-menu > li > a {
  color: #8a6d3b;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > li
  > a:focus {
  background-color: #faebcc;
}
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:hover,
.with-nav-tabs.panel-warning
  .nav-tabs
  > li.dropdown
  .dropdown-menu
  > .active
  > a:focus {
  color: #fff;
  background-color: #8a6d3b;
}
/*  */
.lnu_container {
  display: block;
  margin: 10px auto;
  margin-bottom: 0;
  width: 100%;
  height: auto;
  display: flex;
  justify-content: space-between;
}
.lnu_container p {
  width: 30%;
  height: auto;
  font-size: 12px;
  line-height: 1.2;
  text-align: center;
  border-radius: 2px;
  color: rgba(71, 87, 98, 0.8);
  background: linear-gradient(to right, #06a65a 50%, #eee 50%);
  background-size: 200% 100%;
  background-position: right;
  -webkit-transition: background 0.3s;
  transition: background 0.3s;
}
.got_lowercase,
.got_uppercase,
.got_number {
  background-position: left !important;
  color: rgba(255, 255, 255, 0.9) !important;
}
.show_password_length {
  display: block !important;
}
.password_length {
  padding: 2px 8px;
  position: absolute;
  top: 42px;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_modal {
  padding: 2px 8px;
  position: absolute;
  top: 50.3%;
  right: 21px;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  background: #dd4b39;
  color: white;
  border-color: #d73925;
  border-radius: 4px;
  font-size: 13px;
  display: none;
  -webkit-transition: all 0.1s;
  transition: all 0.1s;
}
.password_length_count {
  background: #06a65a;
  color: rgba(255, 255, 255, 0.9);
}
/*  */
.row {
  margin-top: 40px;
  padding: 0 10px;
}

.clickable {
  cursor: pointer;
}

.panel-heading span {
  margin-top: -20px;
  font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/views/Project/CustomizationTable_Media.vue